import React, { useState } from "react";
import { Button } from "react-bootstrap";

import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import ConfirmDialog from "../../../components/common/ConfirmDialog/ConfirmDialog";
import TextInput from "../../../components/common/TextInput/TextInput";
import Title from "../../../components/common/Title/Title";

import "./styles.css";
import httpclient from "../../../components/httpclient";
import SwalToast from "../../../components/helpers/SwalToast";

const MidTransApproval = () => {
    const [sbgCode, setSbgCode] = useState("");
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [errors, setErrors] = useState({});
    const [submitting, setSubmitting] = useState(false);

    const handleChange = (event) => {
        setSbgCode(event.target.value);

        if (errors.sbgCode) {
            setErrors({});
        }
    };

    const validate = () => {
        const newErrors = {};

        if (!sbgCode || sbgCode === "") {
            newErrors.sbgCode = "Nomor SBG tidak boleh kosong";
        }
        return newErrors;
    };

    const handleCancel = () => {
        setIsConfirmDialogOpen(false);
    };

    const handleSend = (event) => {
        event.preventDefault();
        const newErrors = validate();

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
        } else {
            setSubmitting(true);
            let url = `${process.env.REACT_APP_BASE_API_URL}midtrans/approve-manual?sbg_code=${sbgCode}`;
            httpclient
                .POST(url)
                .then((response) => {
                    console.log(response);
                    setIsConfirmDialogOpen(true);
                })
                .catch((error) => {
                    if (error.response) {
                        console.log(error.response);
                        SwalToast.fire({
                            icon: "error",
                            title: error.response.data.error?.message || "Whoops, something went wrong",
                        });
                    } else {
                        console.log(error);
                        SwalToast.fire({
                            icon: "error",
                            title: "Whoops, something went wrong",
                        });
                    }
                })
                .finally(() => {
                    setSubmitting(false);
                });
        }
    };

    return (
        <div>
            <div className="px-3">
                <div className="py-4 d-flex flex-column" style={{ fontSize: "13px" }}>
                    <Title text={"Payment Approval"} />
                    <Breadcrumb current={"Payment Approval"} />
                </div>

                <div className="d-flex input-bar">
                    <TextInput
                        id={"sbgCode"}
                        label={"Nomor SBG"}
                        width={"25%"}
                        handleChange={handleChange}
                        placeholder={"Masukkan Nomor SBG"}
                        errorText={errors.sbgCode}
                    />
                    <div className="input-bar">
                        <Button
                            variant="primary"
                            className="btn-action btn-send"
                            onClick={handleSend}
                        >
                            Kirim
                        </Button>
                    </div>
                </div>
            </div>
            <ConfirmDialog
                visible={isConfirmDialogOpen}
                handleCancel={handleCancel}
                handleSave={handleCancel}
                hasCancel={false}
                isDangerButton={false}
                actionButtonText={"Selesai"}
                title={"Pembayaran Midtrans Diterima"}
                contentText={
                    <span>Pembayaran dengan nomor SBG <span style={{ fontWeight: "bold" }}>{sbgCode}</span> sudah diterima.</span>
                }
            />
        </div>
    );
};

export default MidTransApproval;
